module.exports = __webpack_public_path__ + "static/apple-badge-44724e38f11aef24351e324c8215f209.svg";